<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Situación</v-btn>
      </template>
      <v-layout row>
          <v-flex xs12>
              <v-card>
                  <progress-bar :show="form.busy"></progress-bar>
                  <form @submit.prevent="createSituation" @keydown="form.onKeydown($event)">
                      <v-card-title primary-title>
                          <h3 v-if="!editingSituation" class="headline mb-0">Crear Situación</h3>
                          <h3 v-else class="headline mb-0">Editar Situación</h3>
                      </v-card-title>

                      <v-card-text>

                          <v-text-field
                            name="title"
                            label="Título"
                            v-validate="'required'"
                            v-model="form.title"
                          ></v-text-field>

                          <v-textarea
                            name="description"
                            label="Descripción"
                            v-validate="'required'"
                            v-model="form.description"
                          ></v-textarea>
                          
                          <select-multiple-input
                            v-validate="'required'"
                            :form="form"
                            :items="schools"
                            label="Escuelas"
                            :v-errors="errors"
                            :value.sync="form.schools"
                            name="schools"
                          ></select-multiple-input>

                          <check-input
                            name="status"
                            :form="form"
                            label="Activa"
                            :value.sync="form.status"
                            :color="'primary'"
                            :v-errors="errors"
                          >
                          </check-input>

                      </v-card-text>

                      <v-card-actions>
                          <submit-button v-if="!editingSituation" :form="form" label="Guardar"></submit-button>
                          <submit-button v-else :form="form" label="Actualizar"></submit-button>
                          <v-btn @click="cancelFormSubmit" >Cancelar</v-btn>
                      </v-card-actions>
                  </form>
              </v-card>
          </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout row>
      <v-flex xs12 >
        <v-data-table
          :headers="headers"
          :items="situations"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.title }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.schools }}</td>
            <td class="text-xs-center">{{ props.item.status == 1 ? 'Si' : 'No' }}</td>
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editSituation(props.item)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="tryDeleteSituation(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar
        </v-card-title>

        <v-card-text>
          Desea eliminar la encuesta?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat
            @click="deleteSituation"
          >
            Si
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="deleteDialog = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import Form from 'vform';

  export default {
    name: 'situation-creation-view',
    data() {
      return {
        form: new Form({
          title: '',
          description: '',
          schools: ['ALL'],
          status: false,
        }),
        headers: [
          { text: 'Título', align: 'center', value: 'title' },
          { text: 'Descripción', align: 'center', value: 'description' },
          { text: 'Escuelas', align: 'center', value: 'schools' },
          { text: 'Activo', align: 'center', value: 'status' },
          { text: 'Acciones', align: 'center', value: 'actions' },
        ],
        situations: [],
        schools: [
          { value: 'ALL', text: 'Todas'},
          { value: '10000', text: 'Early years'},
          { value: '11000', text: 'Elementary School'},
          { value: '12000', text: 'Middle School'},
          { value: '13000', text: 'High School'},
          { value: '14000', text: 'Admissions'},
        ],
        editingSituation: false,
        dialog: false,
        situationQuestions: {},
        deleteDialog: false,
        situationToDelete: ''
      }
    },
    watch: {
      deleteDialog(newValue, oldValue) {
        if (!newValue) {
          this.situationToDelete = ''
        }
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/admissions/situations')
          .then(resp => {
            if (resp.status === 200) {
              this.situations = resp.data;
            }
          })
      },
      async createSituation() {
        if (await this.formHasErrors()) return;

        if (this.editingSituation) {
          this.updateSituation();
          return;
        }

        const { status } = await this.form.post('/api/admissions/situations')
        if (status === 200) {
          this.init()
          this.clearForm()
          this.dialog = false
        } else {
          this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'No se pudo crear la situación',
              title: 'Alerta',
              modal: true
          })
        }
      },
      async updateSituation() {
        const { status } = await this.form.put('/api/admissions/situations')

        if (status === 200) {
          this.init()
          this.clearForm()
          this.dialog = false;
          this.editingSituation = false;
        }
      },
      editSituation(situation) {
        this.editingSituation = true;
        this.dialog = true;
        this.form = new Form({
          id: situation.id,
          title: situation.title,
          description: situation.description,
          schools: situation.schools,
          status: situation.status == 1,
        })
      },
      tryDeleteSituation(situationId) {
        this.situationToDelete = situationId
        this.deleteDialog = true
      },
      deleteSituation() {
        const situationId = this.situationToDelete
        this.deleteDialog = false
        axios.delete(`/api/admissions/situation/${situationId}`)
          .then(resp => {
            if (resp.status === 200) {
              this.situations = this.situations.filter(s => s.id !== situationId)
            }
          })
      },
      clearForm() {
        this.form = new Form({
          title: '',
          description: '',
          schools: ['ALL'],
          status: false,
        })
      },
      cancelFormSubmit() {
        this.clearForm()
        this.dialog = false;
        this.editingSituation = false;
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/situations.vue